import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectFileExportRedirect = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectFileExportRedirect />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectFileExportRedirect = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectFileExportRedirect />
    </Suspense>
  );
};
